import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StatusIndicatorComponent } from "./components/status-indicator/status-indicator.component";
import { StylePaginatorDirective } from "./directive/stylePaginator.directive";

@NgModule({
  declarations: [StatusIndicatorComponent, StylePaginatorDirective],
  imports: [CommonModule],
  exports: [StatusIndicatorComponent,StylePaginatorDirective],
})
export class SharedModule {}
